import React from 'react';
const T = React.PropTypes;

export default class MinorCategory extends React.Component {
  static propTypes = {
    url:                T.string.isRequired,
    majorCategoryIndex: T.number.isRequired,
    name:               T.string.isRequired
  };

  // this should probably be done on the server. there is a test depending on this function
  getTrackingUrl = ({url, majorCategoryIndex}) => {
    var connector = url.search(/\?/) !== -1 ? '&' : '?';
    return url + connector + 'tm_link=tm_homeA_header_t' + majorCategoryIndex + '_sub';
  };

  render () {
    var dataComponentName = 'minorCategory-' + this.props.name;

    return (
      <li className="minorcategories__item">
        <a
          className="minorcategories__link"
          href={this.getTrackingUrl(this.props)}
          data-component={dataComponentName}
        >
          {this.props.name}
        </a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/minorcategories/category/index.js